import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=1e0b6e02&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=1e0b6e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b6e02",
  null
  
)

export default component.exports